import React from 'react';

import {
  GetEntityTypesItem,
  useGetEntityTypes,
} from '../data/useGetEntityTypes';
import {
  GetTemplateListResult,
  useGetTemplateList,
} from '../data/useGetTemplateList';

// very specifically not querying the template tasks in the useGetTemplateList
// we only need them in the getting of a single template
// so, be crystal clear that the return type has everything from the normal template, except the templateTasks
export type Template = Omit<GetTemplateListResult, 'templateTasks'> & {
  entityTypes?: GetEntityTypesItem[];
};

export const useQueryTemplates = (options?: {
  skip: boolean;
}): {
  loading?: boolean;
  error?: boolean;
  data?: Template[];
} => {
  const entityTypes = useGetEntityTypes({ skip: options?.skip });
  const templates = useGetTemplateList({ skip: options?.skip });

  return React.useMemo(() => {
    if (entityTypes.loading || templates.loading) {
      return { loading: true };
    }
    if (entityTypes.error || templates.error) {
      return { error: true };
    }

    const data = templates.data
      // unfortunately, the server returns deleted ones. We don't need them
      ?.filter((template) => !template.wfDeletedOnUTC)
      .map((template) => {
        const templateEntityTypes = entityTypes.data?.filter((entityType) =>
          template.entities?.includes(entityType.cloudId)
        );
        return {
          ...template,
          entityTypes: templateEntityTypes,
        };
      });

    return { data };
  }, [entityTypes, templates]);
};
